export function renderSeparatorFieldLayoutTemplate({
  indent,
  fieldLabel
}: {
  indent: string
  fieldLabel: string
}): string {
  return `${indent}<div className="relative my-4">
${indent}  <div className="absolute inset-0 flex items-center">
${indent}    <Separator className="w-full" />
${indent}  </div>
${indent}  <div className="relative flex justify-center text-xs uppercase">
${indent}    <span className="bg-background px-2 text-muted-foreground">${fieldLabel}</span>
${indent}  </div>
${indent}</div>`
}
